import styled from "styled-components";

export const QuickTestActivityFormStyled = styled.div`
  border-radius: 1rem;
  padding: 1rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  min-width: 500px;
  .f_question_layout {
    .question_label {
      color: ${({ theme }) => theme.COLORS.BLACK_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
    .question_html {
      color: ${({ theme }) => theme.COLORS.BLACK_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }
  .line_horizontal {
    margin: 1rem 0.5rem;
    height: 1px;
    background: ${({ theme }) => theme.COLORS.GRAY_1};
  }
  .ans_layout {
    color: ${({ theme }) => theme.COLORS.GRAY_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
  }
  .input_wrap {
    margin-bottom: 1rem;
  }
`;
